import { render } from "./supplementModel.vue?vue&type=template&id=4d33e01a"
import script from "./supplementModel.vue?vue&type=script&lang=js"
export * from "./supplementModel.vue?vue&type=script&lang=js"

import "./supplementModel.vue?vue&type=style&index=0&id=4d33e01a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__